import { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { proxyFetch } from '../services/Proxy';
import './HealthCard.css';

function HealthCard({ name, url }) {
  const [status, setStatus] = useState(null);
  const [error,  setError]  = useState(false);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const auth  = getAuth();
        const user  = auth.currentUser;
        if (!user) throw new Error('User not authenticated');

        const token = await user.getIdToken();

        // call the Cloud-Run proxy’s /proxy-health endpoint
        const data = await proxyFetch(
          'proxy-health',              // endpoint behind proxy
          token,
          'GET',
          `target=${encodeURIComponent(url)}` // query-string
        );

        console.log('HealthCard payload:', data);
        setStatus(data);
        setError(false);
      } catch (err) {
        console.error(`Health check failed for ${name}:`, err);
        setError(true);
      }
    };

    checkHealth();
  }, [url, name]);

  return (
    <div className="health-card">
      <h3>🔌 {name}</h3>

      {error && <p className="status status-down">❌ Unavailable</p>}

      {status && (
        <>
          <p className="status status-up">
            ✅ Healthy (status: {status.status})
          </p>
          <p className="timestamp">
            🕒 {new Date(status.timestamp).toLocaleString()}
          </p>

          {status.env && Object.keys(status.env).length > 0 && (
            <div className="env-vars">
              {Object.entries(status.env).map(([key, value]) => {
                const boolVal = String(value).toLowerCase() === 'true';
                return (
                  <p
                    key={key}
                    className={`env-var flag ${boolVal ? 'on' : 'off'}`}
                  >
                    🧪 <strong>{key}</strong>: {String(value)}
                  </p>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default HealthCard;
